export default "/Frontend/dist/ppt-hover.137dcb6aa93b200fce5452d649dc6658.svg";